import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';

const plans = [
  {
    key: 'pack_one', name: 'Pack One',
    usd_m: 99, usd_q: 267, usd_y: 950,
    inr_m: 5200, inr_q: 14040, inr_y: 49920,
    agents: '2 Agents', chats: '2,000/month', websites: '5 Websites',
    api: 'Read Only', ai: false, ads: false, popular: false
  },
  {
    key: 'pack_two', name: 'Pack Two',
    usd_m: 149, usd_q: 402, usd_y: 1430,
    inr_m: 7499, inr_q: 20247, inr_y: 71990,
    agents: '5 Agents', chats: '20,000/month', websites: '10 Websites',
    api: 'Read Only', ai: false, ads: true, popular: true
  },
  {
    key: 'pack_advanced', name: 'Pack Advanced',
    usd_m: 299, usd_q: 807, usd_y: 2870,
    inr_m: 11999, inr_q: 32397, inr_y: 115190,
    agents: '20 Agents', chats: 'Unlimited', websites: 'Unlimited',
    api: 'Full Access', ai: true, ads: true, popular: false
  }
];

const features = [
  { label: '1 Client Dashboard',      pack_one: '2 Agents',   pack_two: '5 Agents',   pack_advanced: '20 Agents' },
  { label: 'Websites Integration',    pack_one: '5',          pack_two: '10',         pack_advanced: 'Unlimited' },
  { label: 'Chats/month',             pack_one: '2,000',      pack_two: '20,000',     pack_advanced: 'Unlimited' },
  { label: 'Chat History',     pack_one: 'Forever',    pack_two: 'Forever',    pack_advanced: 'Forever' },
  { label: 'CRM',              pack_one: true,         pack_two: true,         pack_advanced: true },
  { label: 'Leads Dashboard',  pack_one: true,         pack_two: true,         pack_advanced: true },
  { label: 'Contact Form',     pack_one: true,         pack_two: true,         pack_advanced: true },
  { label: 'Analytics',        pack_one: true,         pack_two: true,         pack_advanced: true },
  { label: 'Canned Replies',   pack_one: true,         pack_two: true,         pack_advanced: true },
  { label: 'Priority Support', pack_one: true,         pack_two: true,         pack_advanced: true },
  { label: 'Ticketing System', pack_one: true,         pack_two: true,         pack_advanced: true },
  { label: 'API Access',       pack_one: 'Read Only',  pack_two: 'Read Only',  pack_advanced: 'Full Access' },
  { label: 'API Calls/day',    pack_one: '500',        pack_two: '2,000',      pack_advanced: 'Unlimited' },
  { label: 'AI Chat Bot',      pack_one: false,        pack_two: false,        pack_advanced: true },
  { label: 'Ad Platform Integration', pack_one: false,   pack_two: true,         pack_advanced: true },
];

export default function PlansPage() {
  const isIndia = Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta' ||
                  Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Kolkata' ||
                  navigator.language === 'en-IN';
  const currency = isIndia ? 'inr' : 'usd'; // Auto-detect, no manual toggle
  const [cycle, setCycle] = useState('monthly');

  const getPrice = (plan) => {
    if (currency === 'inr') {
      if (cycle === 'quarterly') return `₹${plan.inr_q.toLocaleString()}`;
      if (cycle === 'yearly') return `₹${plan.inr_y.toLocaleString()}`;
      return `₹${plan.inr_m.toLocaleString()}`;
    } else {
      if (cycle === 'quarterly') return `$${plan.usd_q}`;
      if (cycle === 'yearly') return `$${plan.usd_y}`;
      return `$${plan.usd_m}`;
    }
  };

  const getPeriod = () => {
    if (cycle === 'quarterly') return '/3 months';
    if (cycle === 'yearly') return '/year';
    return '/month';
  };

  const renderVal = (val) => {
    if (val === true) return <span style={{ color: '#00d55b', fontSize: 18 }}>✓</span>;
    if (val === false) return <span style={{ color: '#333', fontSize: 18 }}>✕</span>;
    return <span style={{ color: '#fff', fontSize: 13 }}>{val}</span>;
  };

  return (
    <div style={{ background: '#000', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '64px 24px' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h1 style={{ fontSize: 40, fontWeight: 800, marginBottom: 12 }}>
            Simple, <span style={{ color: '#00d55b' }}>Transparent</span> Pricing
          </h1>
          <p style={{ color: '#555', fontSize: 16 }}>Pay exactly what you see.</p>
        </div>

        {/* Billing cycle toggle */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 40 }}>
          {[['monthly', 'Monthly'], ['quarterly', 'Quarterly'], ['yearly', 'Yearly']].map(([key, label]) => (
            <button key={key} onClick={() => setCycle(key)}
              style={{ padding: '9px 22px', borderRadius: 8, border: `1px solid ${cycle === key ? '#00d55b' : '#1e1e1e'}`, background: cycle === key ? 'rgba(0,213,91,0.1)' : '#111', color: cycle === key ? '#00d55b' : '#555', fontSize: 13, fontWeight: cycle === key ? 700 : 400, cursor: 'pointer' }}>
              {label}
              {key === 'quarterly' && <span style={{ marginLeft: 6, fontSize: 11, color: '#00d55b' }}>-10%</span>}
              {key === 'yearly' && <span style={{ marginLeft: 6, fontSize: 11, color: '#00d55b' }}>-20%</span>}
            </button>
          ))}
        </div>

        {/* Plan cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginBottom: 60 }}>
          {plans.map(plan => (
            <div key={plan.key} style={{ background: plan.popular ? 'rgba(0,213,91,0.05)' : '#0d0d0d', border: `1px solid ${plan.popular ? '#00d55b' : '#1e1e1e'}`, borderRadius: 16, padding: 28, position: 'relative', display: 'flex', flexDirection: 'column' }}>
              {plan.popular && <div style={{ position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)', background: '#00d55b', color: '#000', fontSize: 11, fontWeight: 800, padding: '3px 16px', borderRadius: 20 }}>MOST POPULAR</div>}
              <div style={{ marginBottom: 20 }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>{plan.name}</h3>
                <div style={{ fontSize: 36, fontWeight: 800, color: '#00d55b', marginBottom: 2 }}>{getPrice(plan)}</div>
                {plan.key === 'pack_one' && cycle === 'monthly' && (
                  <div style={{ fontSize: 13, color: '#555', textDecoration: 'line-through', marginBottom: 2 }}>
                    {currency === 'inr' ? '₹5,999' : '$129'}
                  </div>
                )}
                <div style={{ fontSize: 13, color: '#555' }}>{getPeriod()}</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24, flex: 1 }}>
                {[
                  ['👥', plan.agents],
                  ['💬', plan.chats + ' chats/month'],
                  ['🌐', plan.websites],
                  ['🔑', 'API: ' + plan.api],
                  plan.ai ? ['🤖', 'AI Chat Bot included'] : null,
                  plan.ads ? ['📣', 'Ad Platform Integration'] : null,
                ].filter(Boolean).map(([icon, val]) => (
                  <div key={val} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <span>{icon}</span>
                    <span style={{ fontSize: 13, color: '#888' }}>{val}</span>
                  </div>
                ))}
              </div>
              <Link to="/register" style={{ display: 'block', textAlign: 'center', padding: '12px', background: plan.popular ? '#00d55b' : '#111', color: plan.popular ? '#000' : '#fff', border: plan.popular ? 'none' : '1px solid #1e1e1e', borderRadius: 10, fontWeight: 700, fontSize: 14, textDecoration: 'none' }}>
                Get Started →
              </Link>
            </div>
          ))}
        </div>

        {/* Feature comparison table */}
        <h2 style={{ fontSize: 28, fontWeight: 700, textAlign: 'center', marginBottom: 32 }}>
          Full <span style={{ color: '#00d55b' }}>Feature</span> Comparison
        </h2>
        <div style={{ background: '#0d0d0d', border: '1px solid #1e1e1e', borderRadius: 16, overflow: 'hidden' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', background: '#111', padding: '16px 24px', borderBottom: '1px solid #1e1e1e' }}>
            <div style={{ fontSize: 13, color: '#555', fontWeight: 600 }}>FEATURE</div>
            {plans.map(p => (
              <div key={p.key} style={{ textAlign: 'center', fontSize: 13, fontWeight: 700, color: p.popular ? '#00d55b' : '#fff' }}>{p.name}</div>
            ))}
          </div>
          {features.map((f, i) => (
            <div key={f.label} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', padding: '14px 24px', borderBottom: i < features.length - 1 ? '1px solid #111' : 'none', background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)' }}>
              <div style={{ fontSize: 14, color: '#888' }}>{f.label}</div>
              <div style={{ textAlign: 'center' }}>{renderVal(f.pack_one)}</div>
              <div style={{ textAlign: 'center' }}>{renderVal(f.pack_two)}</div>
              <div style={{ textAlign: 'center' }}>{renderVal(f.pack_advanced)}</div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ textAlign: 'center', marginTop: 60 }}>
          <p style={{ color: '#555', fontSize: 14, marginBottom: 20 }}>All plans include a dedicated support team. Bank transfer only — India & US accounts accepted.</p>
          <Link to="/register" style={{ display: 'inline-block', padding: '14px 40px', background: '#00d55b', color: '#000', borderRadius: 12, fontWeight: 800, fontSize: 16, textDecoration: 'none' }}>
            Get Started →
          </Link>
        </div>

      </div>
      <Footer />
    </div>
  );
}